<template>
  <v-container text-xs-center>
    <v-data-table
      class="elevation-5"
      :headers="headers"
      :items="tableData"
      :search="search"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      loading-text="Loading... Please wait"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template v-slot:[`item.athRankName`]="{ item }">
        <v-chip
          :class="getRankTextColor(getRankColor(item.athRankName))"
          :color="getRankColor(item.athRankName)"
          >{{ item.athRankName }}</v-chip
        >
      </template>

      <template v-slot:[`item.resultDate`]="{ item }">
        <v-chip
          v-if="compareDate(item.resultDate) && item.athRankName != 'NA'"
          color="red"
          class="white--text"
          >{{ item.resultDate + " New" }}
          <v-icon> new_releases </v-icon>
        </v-chip>
        <v-chip v-else>{{ item.resultDate }} </v-chip>
      </template>
      <template v-slot:[`item.place`]="{ item }">
        <v-icon
          v-if="item.place > 0 && item.place <= 3"
          :color="getMedalColor(item.place)"
          class="mr-2"
        >
          fas fa-medal
        </v-icon>
        <span>{{ item.place }}</span>
      </template>
      <template v-slot:[`item.timeToNextRank`]="{ item }">
        <v-chip
          v-if="item.timeToNextRank == '999'"
          color="red"
          class="white--text"
        >
          <v-icon> fas fa-fire </v-icon>
        </v-chip>
        <v-chip v-else
          >{{ item.timeToNextRank.replace(/00:/g, "").replace(/000/g, "") }}
        </v-chip>
      </template>

      <template v-slot:[`item.resultTime`]="{ item }">
        {{ item.resultTime.replace(/00:/g, "").replace("000", "") }}
      </template>
      <template v-slot:top>
        <BaseToolbar toolbarTitle="Results & Ranks">
          <template v-slot:toolbarSearch>
            <v-flex xs12 sm3>
              <meetDropdown
                @change-meet="onChangeMeet"
                class="mx-sm-4 mb-3 mb-sm-0"
              ></meetDropdown>
            </v-flex>
          </template>
          <template v-slot:toolbarBtn>
            <v-flex xs12 sm2>
              <GenderSelection
                @change-gender="onChangeGender"
                class="mr-sm-4"
              />
            </v-flex>
            <v-flex xs12 sm2>
              <v-select
                class="mr-sm-4 mt-7 mb-sm-0"
                :items="events.edges"
                :label="'Event'"
                @change="onChangeEvent"
                item-value="node"
              >
                <template v-slot:item="{ item }">
                  {{ getText(item) }}
                </template>
                <template v-slot:selection="{ item }">
                  {{ getText(item) }}
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm2>
              <AthletesDropdown
                labelName="Age From"
                @age="onChangeAgeFrom"
                class="mr-sm-4 mt-7 mb-sm-0"
                v-model="ageFrom"
            /></v-flex>
            <v-flex xs12 sm2>
              <AthletesDropdown
                labelName="Age To"
                class="mr-sm-4 mt-7 mb-sm-0"
                @age="onChangeAgeTo"
                v-model="ageTo"
              />
            </v-flex>
            <v-dialog
              v-model="dialog"
              :retain-focus="false"
              max-width="700px"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-on="on" v-bind="attrs">
                  {{ formTitle }}
                </v-btn>
              </template>
            </v-dialog>
          </template>
        </BaseToolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <rankResultsForm
      :dialog="dialog"
      :index="editedIndex"
      @close-form="closeForm"
      @set-loading="loading = $event"
    />
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AthletesDropdown from "@/components/shared/athletes_ages_dropdown.vue";
import GenderSelection from "@/components/shared/gender_selection.vue";
import meetDropdown from "@/components/shared/meet_dropdown.vue";
import BaseToolbar from "@/components/base/BaseToolbar.vue";
import rankResultsForm from "@/components/forms/rankResultsForm.vue";
import { rankResultsTable } from "@/constants/tableMeetData.js";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
import { event } from "vue-analytics";

export default {
  components: {
    AthletesDropdown,
    GenderSelection,
    meetDropdown,
    BaseToolbar,
    rankResultsForm,
    catValueDropDown,
  },
  data() {
    return {
      search: "",
      page: 1,
      sortBy: "resultDate",
      sortDesc: true,
      itemsPerPage: 50,
      pageCount: 0,
      loading: true,
      level: null,
      athleteId: null,
      meetId: null,
      facilityType: "25m",
      medals: false,
      isFormValid: true,
      newOnly: null,
      bestOnly: null,
      on: "",
      event: { stroke: "FREE", distance: 50 },
      "editedItem.resultTime": "01:00:00.000",
      "editedItem.isOfficial": true,
      daysOld: 31,
      ageFrom: 10,
      ageTo: 20,
      isMobile: false,
      gender: null,
      dialog: false,
      headers: rankResultsTable,
      editedIndex: -1,
      rankClassification:
        this.$route.params.club == 16 ? "SPORTECOS" : "MDA_SWIMMING",
    };
  },
  destroyed(){
    window.removeEventListener('beforeprint', (event) => {});
    window.removeEventListener('afterprint', (event) => {});
  },
  created() {
    Promise.all([
      this.$store.dispatch("allRankLib", {
        rankClassification: this.rankClassification,
      }),
      this.$store.dispatch("allCompetitionEvents"),
    ])
      .then(() => {
         this.handleGetRanks();
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
    window.addEventListener('beforeprint', (event) => {
      document.getElementById("main_side-nav-bar").style.display = "none";
        });
        window.addEventListener('afterprint', (event) => {
      document.getElementById("main_side-nav-bar").style.display = "block";
        });
    //
    if (!(Object.entries(this.$route.query).length === 0)) {
      const {
        gender,
        bestOnly,
        daysOld,
        facilityType,
        newOnly,
        medals,
        meetId,
        athleteId,
        event,
        ageFrom,
        ageTo,
      } = this.$route.query;
      this.gender = gender;
      if (bestOnly) {
        this.bestOnly = JSON.parse(bestOnly.toLowerCase());
      }
      if (daysOld) {
        this.daysOld = parseInt(daysOld);
      }
      this.facilityType = facilityType;
      if (newOnly) {
        this.newOnly = JSON.parse(newOnly.toLowerCase());
      }
      if (medals) {
        this.medals = JSON.parse(medals.toLowerCase());
      }
      if (meetId) {
        this.meetId = parseInt(meetId);
      }
      if(event){
        this.event = event;
      }
      if(ageFrom){
        this.ageFrom = parseInt(ageFrom);
      }
      if(ageTo){
        this.ageTo = parseInt(ageTo);
      }
      this.athleteId = athleteId;
    }
  },
  computed: {
    ...mapGetters([
      "categoryValue",
      "resultsList",
      "rankLib",
      "user",
      "events",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Result" : "Edit Result";
    },
    getFacilityTypes() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          (category) => category.node.category.catName === "SWIMMING_FACILITY"
        );
      } else {
        return [];
      }
    },

    tableData() {
      let place = 1;
      if (this.resultsList.length > 0) {
       let result = this.resultsList
          .filter(
            (item) =>
              (!this.gender || item.gender === this.gender) &&
              (!this.meetId || +item.meetId === +this.meetId) &&
              (!this.ageFrom ||
                new Date().getFullYear() -
                  +item.firstName.match(/(\d+)/)[0] >=
                  this.ageFrom) &&
              (!this.ageTo ||
                new Date().getFullYear() -
                  +item.firstName.match(/(\d+)/)[0] <=
                  this.ageTo) &&
              (!this.event ||
                (this.event.stroke === item.stroke &&
                  this.event.distance === item.distance))
          )
          .sort((item, item2) => {
            return item.resultTime > item2.resultTime ? 1 : -1;
          })
        result.forEach((item, index) => {
          item.place = place;
          place++;
        });
        return result;
      } else {
        return [];
      }
    },
  },

  watch: {
    "$route.params.league": function () {
      this.handleGetRanks();
    },
    "$route.params.club": function () {
      this.handleGetRanks();
    },
  },
  methods: {
   
    getText(item) {
      return `${item.node.stroke} ${item.node.distance}`;
    },
    async onChangeAthlete(value) {
      this.athleteId = value;
      await this.handleGetRanks();
    },
    async onChangeMeet(value) {
      this.meetId = value;
     await this.handleGetRanks();
    },
    async onChangeGender(value) {
      this.gender = value;
     await this.handleGetRanks();
    },
    async onChangeAgeFrom(value) {
      this.ageFrom = value;
      await this.handleGetRanks();
    },
    async onChangeAgeTo(value) {
      this.ageTo = value;
      await this.handleGetRanks();
    },
    async onChangeEvent(value) {
      this.event = { stroke: value.stroke, distance: value.distance };
      await this.handleGetRanks();
    },

    brightnessByColor(color) {
      // eslint-disable-next-line
      var color = "" + color,
        isHEX = color.indexOf("#") == 0,
        isRGB = color.indexOf("rgb") == 0;
      if (isHEX) {
        const hasFullSpec = color.length == 7;
        var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
        if (m)
          // eslint-disable-next-line
          var r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16),
            g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16),
            b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16);
      }
      if (isRGB) {
        // eslint-disable-next-line
        var m = color.match(/(\d+){3}/g);
        if (m)
          // eslint-disable-next-line
          var r = m[0],
            // eslint-disable-next-line
            g = m[1],
            // eslint-disable-next-line
            b = m[2];
      }
      if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
    },
    getRankTextColor(rankColor) {
      var brbyColor = this.brightnessByColor(rankColor);

      return brbyColor > 130 ? "black--text" : "white--text";
    },
    getRankColor(rankName) {
      return rankName.match(new RegExp("REFRESH"))
        ? "red"
        : this.rankLib.edges.filter((item) => item.node.rankDesc == rankName)[0]
            .node.rankColor;
    },
    getMedalColor(level) {
      var tagcolor = "";
      switch (parseInt(level)) {
        case 1:
          tagcolor = "#FFD700";
          break;
        case 2:
          tagcolor = "#C0C0C0";
          break;
        case 3:
          tagcolor = "#CD7F32";
          break;
        default:
          tagcolor = "grey";
      }
      return tagcolor;
    },

    async handleGetRanks() {
      this.$router.replace({
        query: {
          gender: this.gender,
          meetId: this.meetId,
          ageFrom: this.ageFrom,
          ageTo: this.ageTo,
          event: this.event.stroke + " " + this.event.distance,
        },
      });
      Promise.all([
        this.$store.dispatch("allResultsList", {
          gender: this.gender,
          leagueSeqno: this.$route.params.league,
          clubId: this.$route.params.club,
          teamId: this.teamId,
          event: this.event,
          ageFrom: this.ageFrom,
          ageTo: this.ageTo,
          rankClassification: this.rankClassification,
        }),
      ])
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    compareDate: function (item) {
      return Math.abs((new Date() - new Date(item)) / 86400000) < this.daysOld;
    },
    handleAddResult() {
      if (this.athleteId) {
        this.$store.dispatch("resultMerge", {
          resultId: this.editedItem.resultId || 0,
          setLibSetId: this.editedItem.setLibSetId,
          athleteId: this.athleteId,
          setId: this.editedItem.setId || 1,
          resultTime: this.editedItem.resultTime,
          resultDate: this.editedItem.resultDate,
          comments: this.editedItem.comments,
          isOfficial: this.editedItem.isOfficial,
          pulse: this.editedItem.pulse,
          facilityType: this.editedItem.facilityType,
          meetId: this.editedItem.meetId,
          place: this.editedItem.place,
          updateSource: "VueJS",
          firstName: this.editedItem.firstName,
          stroke: this.editedItem.stroke,
          gender: this.editedItem.gender,
        });
      }
    },
    handleDeleteResult() {
      this.$store.dispatch("DeleteResult", {
        resultId: this.editedItem.resultId,
      });
    },
    editItem(item) {
      this.editedIndex = this.resultsList.findIndex((x) => x === item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.loading = true;
      this.$store
        .dispatch("DeleteResult", {
          resultId: item.resultId,
        })
        .then(() => {
          this.$toast.error("Result has been deleted");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.closeForm();
        });
    },

    closeForm() {
      this.dialog = false;
      this.editedIndex = -1;
    },
    save() {
      this.handleAddResult();
      this.close();
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
::-webkit-datetime-edit-ampm-field {
  display: none;
}
::-webkit-datetime-edit-millisecond-field {
  color: red;
  font-variant-numeric: slashed-zero;
  padding: 1px;
}
::-webkit-datetime-edit-hour-field {
  display: none;
  pointer-events: auto;
  color: transparent;
  background: #f5f5f5;
}

@media screen and (max-width: 600px) {
  .v-toolbar__content {
    flex-wrap: wrap !important;
    height: auto !important;
    justify-content: center !important;
  }
}
</style>
